import star from "./assets/star-outline.svg";
import starFilled from "./assets/star.svg";
import sync from "./assets/sync.svg";
import { getCocktail } from "./cocktails.js";
function populateCocktaislList(cocktails) {
  const cocktailsList = document.getElementById("cocktails-list");
  cocktails.forEach((cocktail) => {
    const cocktailItem = document.createElement("li");
    cocktailItem.classList.add("cocktail-list-item");
    const cocktailText = document.createElement("span");
    cocktailText.textContent = cocktail.name;
    const cocktailStar = document.createElement("img");
    cocktailStar.id = `star-${cocktail.id}`;
    cocktailStar.addEventListener("click", () => addFavoriteCocktail(cocktail));
    if (
      JSON.parse(localStorage.getItem("favoriteCocktails"))?.some(
        (fav) => fav.id === cocktail.id,
      )
    ) {
      cocktailStar.src = starFilled;
    } else {
      cocktailStar.src = star;
    }
    cocktailStar.alt = "star";
    cocktailItem.appendChild(cocktailText);
    cocktailItem.appendChild(cocktailStar);

    cocktailItem.addEventListener("click", async (event) => {
      if (event.target === cocktailStar) return;
      const cocktailData = await getCocktail(cocktail.id);
      createCurrentCocktailCard(cocktailData.data);
    });
    cocktailsList.appendChild(cocktailItem);
  });

  function addFavoriteCocktail(cocktail) {
    const cocktailStar = document.getElementById(`star-${cocktail.id}`);
    const favoriteCocktails =
      JSON.parse(localStorage.getItem("favoriteCocktails")) || [];
    if (!favoriteCocktails.some((fav) => fav.id === cocktail.id)) {
      favoriteCocktails.push(cocktail);
      localStorage.setItem(
        "favoriteCocktails",
        JSON.stringify(favoriteCocktails),
      );
      cocktailStar.src = starFilled;
    } else {
      cocktailStar.src = star;

      localStorage.setItem(
        "favoriteCocktails",
        JSON.stringify(
          favoriteCocktails.filter((fav) => fav.id !== cocktail.id),
        ),
      );
    }
  }
}

function handleModal(cocktails) {
  const filterButton = document.getElementById("filter-button");
  const closeFiltersButton = document.getElementById("close-filters");
  const filtersModal = document.getElementById("filters-modal");
  const searchInput = document.getElementById("search-input");
  const searchButton = document.getElementById("search-button");
  filterButton.addEventListener("click", () => {
    document.body.classList.add("modal-open");
    filtersModal.showModal();
  });

  closeFiltersButton.addEventListener("click", () => {
    closeFunction(cocktails);
  });
  populateCategories();
  populateGlassTypes();
  populateIngredients();
  searchButton.addEventListener("click", () => {
    const query = searchInput.value.toLowerCase();
    const filteredCocktails = cocktails.filter((cocktail) =>
      cocktail.name.toLowerCase().includes(query),
    );
    const cocktailsList = document.getElementById("cocktails-list");
    cocktailsList.innerHTML = "";
    if (filteredCocktails.length === 0) {
      cocktailsList.innerHTML = "<p>Oh no! No cocktails found!.</p>";
      return;
    }
    populateCocktaislList(filteredCocktails);
  });

  async function closeFunction(cocktails) {
    document.body.classList.remove("modal-open");
    filtersModal.close();

    const cocktailsList = document.getElementById("cocktails-list");
    cocktailsList.innerHTML =
      "<div class='sync-container'><img id='sync' src='" +
      sync +
      "' alt='Syncing...' /></div>";

    const categorySelect = document.getElementById("category-select");
    const glassTypeSelect = document.getElementById("glass-type-select");
    const ingredientSelect = document.getElementById("ingredient-select");
    const isAlcoholicCheckbox = document.getElementById("is-alcoholic");
    const favouriteCheckbox = document.getElementById("favourite");

    const filteredCocktails = [];

    const filteringPromises = cocktails.map(async (cocktail) => {
      let fits = true;

      if (categorySelect.value && cocktail.category !== categorySelect.value) {
        fits = false;
      }
      if (
        glassTypeSelect.value &&
        cocktail.glass !== glassTypeSelect.value
      ) {
        fits = false;
      }
      if (
        isAlcoholicCheckbox.checked &&
        cocktail.alcoholic !== isAlcoholicCheckbox.checked
      ) {
        fits = false;
      }
      if (
        favouriteCheckbox.checked &&
        !JSON.parse(localStorage.getItem("favoriteCocktails"))?.some(
          (fav) => fav.id === cocktail.id,
        )
      ) {
        fits = false;
      }
      if (fits && ingredientSelect.value) {
        const coctailIngredients = await getCocktail(cocktail.id).then(
          (res) => res.data.ingredients,
        );

        for (const ingredient of coctailIngredients) {
          if (ingredient.type === ingredientSelect.value) {
            fits = true;
            break;
          } else {
            fits = false;
          }
        }
      }

      return { cocktail, fits };
    });

    const results = await Promise.all(filteringPromises);

    results.forEach(({ cocktail, fits }) => {
      if (fits) {
        filteredCocktails.push(cocktail);
      }
    });

    cocktailsList.innerHTML = "";
    if (filteredCocktails.length === 0) {
      cocktailsList.innerHTML = "<p>Oh no! No cocktails found!.</p>";
      return;
    }
    populateCocktaislList(filteredCocktails);
  }
  async function populateCategories() {
    const categorySelect = document.getElementById("category-select");
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Select category";
    categorySelect.appendChild(defaultOption);
    const url = "https://cocktails.solvro.pl/api/v1/cocktails/categories";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const categories = await response.json();
      categories.data.forEach((category) => {
        if (category === "Other / Unknown") return;
        const option = document.createElement("option");
        option.value = category;
        option.textContent = category;
        categorySelect.appendChild(option);
      });
      const otherOption = document.createElement("option");
      otherOption.value = "Other / Unknown";
      otherOption.textContent = "Other / Unknown";
      categorySelect.appendChild(otherOption);
    } catch (error) {
      console.error(error);
    }
  }
  async function populateGlassTypes() {
    const glassTypeSelect = document.getElementById("glass-type-select");
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Select glass type";
    glassTypeSelect.appendChild(defaultOption);
    const url = "https://cocktails.solvro.pl/api/v1/cocktails/glasses";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const glassTypes = await response.json();
      glassTypes.data.forEach((glass) => {
        const option = document.createElement("option");
        option.value = glass;
        option.textContent = glass;
        glassTypeSelect.appendChild(option);
      });
    } catch (error) {
      console.error(error);
    }
  }
  async function populateIngredients() {
    const ingredientSelect = document.getElementById("ingredient-select");
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Select ingredient";
    ingredientSelect.appendChild(defaultOption);
    const url = "https://cocktails.solvro.pl/api/v1/ingredients/types";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const ingredients = await response.json();
      ingredients.data.forEach((ingredient) => {
        if (ingredient === "null") return;
        const option = document.createElement("option");
        option.value = ingredient;
        option.textContent = ingredient;
        ingredientSelect.appendChild(option);
      });
    } catch (error) {
      console.error(error);
    }
  }
}
function createCurrentCocktailCard(cocktail) {
  const cocktailCard = document.getElementById("current-cocktail");
  const ingredients = Array.isArray(cocktail.ingredients)
    ? cocktail.ingredients
    : [];
  console.log(cocktail);
  cocktailCard.innerHTML = `
        <header>
            <h1>${cocktail.name}</h1>
            <img src="${cocktail.imageUrl}" alt="${cocktail.name}">
        </header>
        <section class="ingredients">
        <h3>Ingredients</h3>
        <ul>
            ${ingredientsList(ingredients)}
        </ul>
        </section>
        <section class="instructions">
        <h3>Instructions</h3>
            <p>${cocktail.instructions}</p>
        </section>

    `;
  for (const ingredient of ingredients) {
    const ingredientButton = cocktailCard.querySelector(
      `.view-ingredient-button[data-ingredient="${ingredient.name}"]`,
    );
    if (!ingredientButton) continue;
    ingredientButton.addEventListener("click", () =>
      showIngredientDetails(ingredient.id),
    );
  }

  async function showIngredientDetails(ingredientId) {
    const url = `https://cocktails.solvro.pl/api/v1/ingredients/${ingredientId}`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const ingredientData = await response.json();
      populateIngredientModal(ingredientData.data);
    } catch (error) {
      console.error(error);
    }
    function populateIngredientModal(ingredient) {
      const ingredientModal = document.getElementById("ingredient-modal");
      ingredientModal.innerHTML = `
        <header>
          <h2>${ingredient.name}</h2>
          <button id="close-ingredient-modal">Close</button>
        </header>
        ${ingredient.imageUrl ? `<img src="${ingredient.imageUrl}" alt="${ingredient.name}">` : ""}
        <section class="ingredient-details">
          <p>${ingredient.description || "No description available."}</p>
          <div>
          <p>Type: ${ingredient.type || "Unknown"}</p>
        ${ingredient.alcohol ? `<p>Percentage: ${ingredient.percentage || "Unknown"}</p>` : ""}

          <div>
        </section>
      `;
      ingredientModal.showModal();
      document
        .getElementById("close-ingredient-modal")
        .addEventListener("click", () => {
          ingredientModal.close();
        });
    }
  }

  function ingredientsList(ingredients) {
    if (!Array.isArray(ingredients) || ingredients.length === 0) {
      return "<li><p>No ingredients available.</p></li>";
    }

    return ingredients
      .map((ingredient) => {
        let ingredientName = ingredient.name ? ingredient.name : "";
        let ingredientMeasure = ingredient.measure
          ? ingredient.measure
          : "Top with";

        return `<li>
        <div>
                <p>${ingredientName}:</p>
                <button class="view-ingredient-button" data-ingredient="${ingredientName}">Details</button>
                </div>
                <p>${ingredientMeasure}</p>

            </li>`;
      })
      .join("");
  }
}

export { populateCocktaislList, createCurrentCocktailCard, handleModal };
